import Path from "../../services/paths";
import CoreTypeAction from "../actions/coreTypeAction";
import utils from "../common/utils";

class CoreTypeMiddleware {
  static getCoreTypes() {
    return dispatch => {
      dispatch(CoreTypeAction.coretypeRequest());
      utils.get_token()
        .then(token => {
          fetch(Path.GET_CORE_TYPE_, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`
            }
          })
            .then(res => res.json())
            .then(res => {
              if (res.error) {
                // console.log("ERROR", res.error);
              }
              if (res.error) {
                // console.log("ERROR", res.error);
              } else {
                let newCoreType = []
                newCoreType = res.filter(item =>  item !== "0" && item !== "not available" && item !== "Coretype not available")
                dispatch(CoreTypeAction.coretypeSuccessul(newCoreType));
              }
            })
            .catch(error => {
              // console.log("IN CATCH");
              dispatch(CoreTypeAction.coretypeFailed(error));
            });
        })
        .catch(error => {
          // console.log("IN CATCH");
          dispatch(CoreTypeAction.coretypeFailed(error));
        });
    };
  }
}

export default CoreTypeMiddleware;
